module.exports = __webpack_public_path__ + "img/freespin_multiplier.67b99fac.png";